<template lang="html">
  <!-- it's helpful to add a click event to a button-->
  <button class="button" type="button" @click="$emit('click', $event)">
    <TodoIcon v-if="icon" :icon="icon" :class="[pageColor]"/>
    <div :class="[pageColor]">{{label}}</div>
  </button>
</template>

<script>
import TodoIcon from '@/components/TodoIcon.vue';

export default {
  components: {
    TodoIcon,
  },
  data() {
    return {
      showIcon: false,
    };
  },
  props: {
    icon: {
      type: String,
      default: 'check',
    },
    label: {
      type: String,
      default: 'Click here!',
    },
    pageColor: String,
  },
};
</script>

<style lang="stylus" scoped>

.button
  background-color: transparent
  border: none
  align-items: center
  font-size: 8px
  cursor: pointer
  font-family: futura-pt, sans-serif
  font-weight: 400;
  font-style: normal
  text-transform: uppercase
  padding: 1px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

  &:focus
    background-color: black
    border:transparent
    outline: none

  &:active
    background-color: white
    border:transparent

  &:hover
    background-color: black
    border:transparent

  div
    background-color: inherit

  .icon
    padding-bottom: 2px
    padding-left 10px
    padding-right: 10px

  .label
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase

</style>
